<div class="map">
  <highcharts-chart [options]="($any(data()).content | tableToCountryData | countryChartOptions)!"
                    (chartInstance)="chartInstance = $event" [constructorType]="'mapChart'"/>
  <div class="zoom">
    <sd-6-17-1-icon
      (click)="zoomOut($event)"
      color="primary"
      library="{{ iconLibrary }}"
      name="system/minus-circle"></sd-6-17-1-icon>
    <sd-6-17-1-icon
      (click)="zoomIn($event)"
      color="primary"
      library="{{ iconLibrary }}"
      name="system/plus-circle"></sd-6-17-1-icon>
  </div>
</div>
